import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    *,
    *:before,
    *:after {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -msbox-sizing: border-box;
    }

    ${({ theme }) => theme.mediaQueries.md} {
        header,
        .mobile-navbar,
        main,
        footer {
            max-width: 100vw !important;
        }
    }

    html, body {
        overflow-x: hidden;
    }

    body {
        width: 100%;
        color: ${(props) => props.theme.colors.text.primary};
        margin: 0 !important;
        padding: 0;
        font-family: Inter-Regular, sans-serif;
        position: relative;
    }

    main {
        grid-area: main;
        display: flex;
        flex-direction: column;
        align-items: ${(props) => (props.theme.rtl ? 'flex-end' : 'flex-start')};
        position: relative;
        width: 100%;
        overflow: hidden;
    }


    a {
        text-decoration: none;
        color: inherit;

        &:hover,
        :visited {
            color: inherit;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        margin: 0;
    }

    .MuiPopover-root {
        z-index: 12002 !important;
    }

    .Toastify__toast-container {
        z-index: 12003;
        top: 88px;
        max-width: 100%;
        width: max-content;

        .Toastify__close-button > svg {
            display: none;
        }

        .Toastify__toast {
            border-radius: 6px;
            padding: 14px 16px;
            box-shadow: none;
            max-width: 100%;

            ${({ theme }) => theme.mediaQueries.md} {
                max-width: 95%;
                margin: 0 auto;
            }

            &--success {
                background: ${(props) => props.theme.colors.palette.lightOrDarkGreen};
                border: 1px solid ${(props) => props.theme.colors.palette.primary};
            }

            &--error {
                background: ${(props) => props.theme.colors.palette.lightOrDarkRed};
                border: 1px solid ${(props) => props.theme.colors.palette.red};
            }
        }
    }

    .MuiPopover-paper {
        box-shadow: 0 1px 2px rgb(36 43 50 / 20%), 0 0 2px rgb(36 43 50 / 12%), 0 0 2px rgb(36 43 50 / 14%) !important;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    .custom-popper {
        background: white;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
        border-radius: 8px;

        &::after {
            top: calc(50% - 10px / 2 - 95px);
            right: ${(props) => (props.theme.rtl ? '-10px' : 'unset')};
            left: ${(props) => (props.theme.rtl ? 'unset' : '-10px')};
            width: 0;
            height: 0;
            border-top: 11px solid transparent;
            border-bottom: 11px solid transparent;
            border-right: ${(props) => (!props.theme.rtl ? '11px solid #fff' : 'unset')};
            border-left: ${(props) => (props.theme.rtl ? '11px solid #fff' : 'unset')};
            content: '';
            display: block;
            position: absolute;
            clear: both;
        }

        &.left-start {
            &::after {
                top: calc(50% - 10px / 2 - 95px);
                left: ${(props) => (props.theme.rtl ? '-10px' : 'unset')};
                right: ${(props) => (props.theme.rtl ? 'unset' : '-10px')};
                width: 0;
                height: 0;
                border-top: 11px solid transparent;
                border-bottom: 11px solid transparent;
                border-left: ${(props) => (!props.theme.rtl ? '11px solid #fff' : 'unset')};
                border-right: ${(props) => (props.theme.rtl ? '11px solid #fff' : 'unset')};
                content: '';
                display: block;
                position: absolute;
                clear: both;
            }
        }

        ${({ theme }) => theme.mediaQueries.md} {
            display: none;
        }
    }

    /* Scrollbar */
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 20px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.colors.text.tertiary};
        border-radius: 20px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.colors.text.disabled};
    }
`;
